/**
 * @typedef ContractorTypes
 * @property {'saas'} SAAS
 * @property {'enterprise'} ENTERPRISE
 * @property {'agency'} AGENCY
 */

/** @type {Readonly<ContractorTypes>} */
const types = {
  SAAS: 'saas',
  ENTERPRISE: 'enterprise',
  AGENCY: 'agency',
};

module.exports = types;
